export default {"src":"/_next/static/media/white-shield.a155c9ac.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};